import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './root/App';
import reportWebVitals from './reportWebVitals';
import { Helmet, HelmetProvider  } from 'react-helmet-async';

const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);

  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <Helmet>
          <meta name='deascription' content='Strona wykonana jako projekt zespołowy, na potrzeby członków koła naukowego Teambit'/>
          <meta charSet='utf-8'/>
          <meta name='author' content='Nina Bąkowska, Marek Baranowski, Marek Cichoń, Bartosz Anger, Jarosław Smolira' />
          <meta name='keywords' content='Teambit, koło naukowe, politechnika opolska' />
          <meta name='robots' content='index,follow' />
          <meta name="deklaracja-dostępności" content="https://teambit.po.edu.pl/deklaracja-dostepnosci"/>
        </Helmet>
        <App />
      </HelmetProvider >
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
